/**
 * Reads an environment variable by key (e.g. 'API_BASE_URL').
 * In Docker containers: reads from window.__PXTRA_ENV (generated at startup).
 * In local dev: falls back to VITE_<key> from import.meta.env (Vite build-time).
 */

declare global {
  interface Window {
    __PXTRA_ENV?: Record<string, string>;
  }
}

export function env(key: string): string {
  const value = window.__PXTRA_ENV?.[key] || import.meta.env[`VITE_${key}`] || '';
  if (!value && import.meta.env.DEV) {
    console.warn(`[env] Missing environment variable: ${key}`);
  }

  return value;
}
